import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { CustomHeights } from 'src/types';

import { StyledIconButtonProps } from '.';

const getButtonSize = (size: string | undefined, customHeights: CustomHeights): string | number | undefined => {
  switch (size) {
    case 'medium':
      return customHeights.regularButton;
    case 'small':
      return customHeights.smallButton;
    default:
      return undefined;
  }
};

const useStyles = makeStyles<Theme, StyledIconButtonProps>(theme => ({
  container: {
    '& path': {
      fill: (props: StyledIconButtonProps) => {
        if (props.defaultIconColor) {
          return '';
        }
        if (props.primary) {
          return theme.palette.common.white;
        }

        return props.isSelected ? theme.palette.common.blue400 : theme.palette.common.gray500;
      },
    },
    '&:disabled': {
      backgroundColor: theme.palette.common.gray300,
    },
    '&:hover': {
      '& path': {
        fill: (props: StyledIconButtonProps) => (props.primary ? '' : theme.palette.common.gray600),
      },
      backgroundColor: props => (props.primary ? theme.palette.common.blue600 : theme.palette.common.gray200),
    },
    alignItems: 'center',
    backgroundColor: (props: StyledIconButtonProps) => {
      if (props.isSelected) {
        return theme.palette.common.blue100;
      }
      if (props.primary) {
        return theme.palette.common.blue400;
      }
      return '';
    },
    borderRadius: '50%',
    display: 'inline-flex',
    height: props => getButtonSize(props.size, theme.customHeights),
    justifyContent: 'center',
    padding: 0,
    width: (props: StyledIconButtonProps) => getButtonSize(props.size, theme.customHeights),
  },
}));

export default useStyles;
